import { api, endpoint } from '@/plugins/axios'

const getTimetable = async ({ classId, section }) => {
  const institutionId = localStorage.getItem('institutionId')
  const res = await api.get(`${endpoint.TIMETABLE}/class/${classId}/section/${section}`, { params: { institutionId } })

  return res
}

const createTimetable = async ({ classId, section, batchId, grade }) => {
  const institutionId = localStorage.getItem('institutionId')
  const res = await api.post(`${endpoint.TIMETABLE}/class/${classId}/section/${section}`, { grade },
    { params: { institutionId, batchId } })

  return res
}

const updateDay = async ({ classId, section, day, periods }) => {
  const institutionId = localStorage.getItem('institutionId')
  const res = await api.put(`${endpoint.TIMETABLE}/class/${classId}/section/${section}/day/${day}`, periods,
    { params: { institutionId } })

  return res
}

const deletePeriod = async ({ classId, section, day, periodNumber }) => {
  const institutionId = localStorage.getItem('institutionId')
  const res = await api.delete(`${endpoint.TIMETABLE}/class/${classId}/section/${section}/day/${day}/period/${periodNumber}`,
    { params: { institutionId } })

  return res
}

const getWeekView = async ({ classId, section, anyDateInWeek }) => {
  const institutionId = localStorage.getItem('institutionId')
  const res = await api.get(`${endpoint.TIMETABLE}/class/${classId}/section/${section}/week`,
    { params: { institutionId, anyDateInWeek } })

  return res
}

export default {
  getTimetable,
  createTimetable,
  updateDay,
  deletePeriod,
  getWeekView,
}
